import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding, withViewTransitions } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  provideClientHydration,
  withEventReplay,
  withIncrementalHydration,
} from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideAuthInitializer } from '@vendorhub/shared/auth';
import {
  authInterceptor,
  correlationIdInterceptor,
  errorInterceptor,
} from '@vendorhub/shared/data-access';
import { provideTranslation } from '@vendorhub/shared/i18n';
import { ENVIRONMENT } from '@vendorhub/shared/config';
import { provideSentry } from '@vendorhub/shared/analytics';
import { provideVhIcons } from '@vendorhub/shared/ui';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(appRoutes, withComponentInputBinding(), withViewTransitions()),
    provideHttpClient(
      withFetch(),
      withInterceptors([correlationIdInterceptor, authInterceptor, errorInterceptor]),
    ),
    provideClientHydration(withIncrementalHydration(), withEventReplay()),
    provideAnimationsAsync(),
    provideTranslation(),
    provideSentry(),
    { provide: ENVIRONMENT, useValue: environment },
    provideAuthInitializer(),
    provideVhIcons(),
  ],
};
